import {css, cx} from "@panda/css";

import {Image} from "@pg-design/image-module";
import {consultantList, IConsultant as ILeadModalConsultant} from "@pg-rp/consultants";

type variantType = "small" | "medium" | "large";

interface Props {
    variant?: variantType;
    className?: string;
}

export const HotlineConsultantsImages = (props: Props) => {
    const {variant = "medium", className} = props;
    const imgSize = getImageSize(variant);

    return (
        <div className={cx(consultantsStyle, className)}>
            {consultantList.slice(0, 4).map((consultant, index) => {
                const imageSrc = getImage(variant, consultant);
                return (
                    <Image
                        key={consultant.fullName}
                        src={imageSrc}
                        width={imgSize}
                        height={imgSize}
                        alt={consultant.fullName}
                        loading="lazy"
                        className={cx(imageBaseStyle, index > 0 && imageOffset(variant), imageZIndexStyles[index])}
                    />
                );
            })}
        </div>
    );
};

const getImageSize = (variant: variantType) => {
    switch (variant) {
        case "small":
            return "70";
        case "large":
        case "medium":
        default:
            return "90";
    }
};

const getImage = (variant: variantType, consultant: ILeadModalConsultant) => {
    switch (variant) {
        case "small":
            return consultant.image.s72;
        case "large":
            return consultant.image.s216;
        case "medium":
        default:
            return consultant.image.s144;
    }
};

const imageOffset = (variant: variantType) => {
    switch (variant) {
        case "small":
            return css({
                ml: "-2.8rem"
            });
        case "large":
        case "medium":
        default:
            return css({
                ml: "-3.2rem"
            });
    }
};

const imageZIndexStyles = [css({zIndex: 4}), css({zIndex: 3}), css({zIndex: 2}), css({zIndex: 1})];

const consultantsStyle = css({
    display: "flex",
    justifyContent: "center",
    mb: 2
});

const imageBaseStyle = css({
    borderRadius: "50%",
    border: "0.5rem solid var(--colors-primary)",
    backgroundColor: "var(--colors-primary)"
});
import {css, cx} from "@panda/css";

import {Image} from "@pg-design/image-module";
import {consultantList, IConsultant as ILeadModalConsultant} from "@pg-rp/consultants";

type variantType = "small" | "medium" | "large";

interface Props {
    variant?: variantType;
    className?: string;
}

export const HotlineConsultantsImages = (props: Props) => {
    const {variant = "medium", className} = props;
    const imgSize = getImageSize(variant);

    return (
        <div className={cx(consultantsStyle, className)}>
            {consultantList.slice(0, 4).map((consultant, index) => {
                const imageSrc = getImage(variant, consultant);
                return (
                    <Image
                        key={consultant.fullName}
                        src={imageSrc}
                        width={imgSize}
                        height={imgSize}
                        alt={consultant.fullName}
                        loading="lazy"
                        className={cx(imageBaseStyle, index > 0 && imageOffset(variant), imageZIndexStyles[index])}
                    />
                );
            })}
        </div>
    );
};

const getImageSize = (variant: variantType) => {
    switch (variant) {
        case "small":
            return "70";
        case "large":
        case "medium":
        default:
            return "90";
    }
};

const getImage = (variant: variantType, consultant: ILeadModalConsultant) => {
    switch (variant) {
        case "small":
            return consultant.image.s72;
        case "large":
            return consultant.image.s216;
        case "medium":
        default:
            return consultant.image.s144;
    }
};

const imageOffset = (variant: variantType) => {
    switch (variant) {
        case "small":
            return css({
                ml: "-2.8rem"
            });
        case "large":
        case "medium":
        default:
            return css({
                ml: "-3.2rem"
            });
    }
};

const imageZIndexStyles = [css({zIndex: 4}), css({zIndex: 3}), css({zIndex: 2}), css({zIndex: 1})];

const consultantsStyle = css({
    display: "flex",
    justifyContent: "center",
    mb: 2
});

const imageBaseStyle = css({
    borderRadius: "50%",
    border: "0.5rem solid var(--colors-primary)",
    backgroundColor: "var(--colors-primary)"
});
